export const deleteArtifacts = async (
  artifactIds: string[],
  deleteOne: (artifactId: string) => Promise<unknown>
): Promise<string[]> => {
  const failedIds: string[] = [];
  for (const artifactId of artifactIds) {
    try {
      await deleteOne(artifactId);
    } catch {
      failedIds.push(artifactId);
    }
  }
  return failedIds;
};
